// Shared thresholds for gating Algolia search requests: wait for a typing
// pause and require a minimum query length before searching, to cut down on
// request volume.
export const SEARCH_DEBOUNCE_MS = 500;
export const MIN_QUERY_LENGTH = 3;
